export const collectAppsByGroups = (apps) => {
  if (!apps) return {};
  const res = apps?.reduce((acc, app) => {
    return {
      ...acc,
      [app.group_name]: [
        ...(acc[app.group_name] || []),
        {
          pba_name: app.pba_name,
          app_types_names: app.app_types_names,
          pba_number: app.pba_number,
          group_id: app.group_id,
          appMinimumServingPerCountry: app.appMinimumServingPerCountry,
          appMinimumServingDefault: app.appMinimumServingDefault,
        },
      ],
    };
  }, {});
  return res;
};

export const createAppsData = (apps) => {
  const cloneData = structuredClone(apps);
  return Object.assign(
    {},
    ...Object.entries(cloneData).map((app) => {
      return {
        [app[0]]: {
          group_name: app[0],
          open: false,
          group_id: app[1][0].group_id,
          matches: false,
          checked: false,
          apps: app[1].map((item) => {
            return {
              pba_number: item.pba_number,
              pba_name: item.pba_name,
              checked: false,
              app_types_names: item.app_types_names,
              group_name: app[0],
              matches: false,
              group_id: app[1][0].group_id,
              appMinimumServingPerCountry: item.appMinimumServingPerCountry,
              appMinimumServingDefault: item.appMinimumServingDefault,
            };
          }),
        },
      };
    }),
  );
};

//export const createGroupNames = (apps) => Object.entries(apps).map((i) => i[0]);

//export default collectionOfAppsGroups;
